import React from "react";
import { getRemaindays } from "../../../../../../../Common/AllDateTimeReleventFormate";

export default function GetCompletedDays({ enddate }) {
  const day = getRemaindays(enddate);
  const absDays = Math.abs(day); // Ensure the number of day is always positive

  let message;

  // For days > 365 (i.e., more than a year)
  if (absDays > 365) {
    const years = Math.floor(absDays / 365);
    const months = Math.floor((absDays % 365) / 30); // Approximation of months
    const days = absDays % 30; // Remaining days after calculating years and months

    // Construct message based on years, months, and days
    message = `${years} year${years > 1 ? "s" : ""}`;
    if (months > 0) {
      message += ` ${months} month${months > 1 ? "s" : ""}`;
    }
    if (days > 0) {
      message += ` ${days} day${days > 1 ? "s" : ""}`;
    }
  }
  // For days > 30 (i.e., more than a month but less than a year)
  else if (absDays > 30) {
    const months = Math.floor(absDays / 30); // Approximation of months
    const days = absDays % 30; // Remaining days after calculating months

    // Construct message based on months and days
    message = `${months} month${months > 1 ? "s" : ""}`;
    if (days > 0) {
      message += ` ${days} day${days > 1 ? "s" : ""}`;
    }
  }
  // If the days are less than or equal to 30
  else {
    if (day > 0) {
      message = `${absDays} day ago`;
    } else if (day < 0) {
      message = `${absDays} day ago`;
    } else if (day == 0) {
      message = `today`;
    } else {
      message = `${absDays} day ago`;
    }
  }

  return (
    <>
      {enddate ? (
        <span className="deadline-p d-flex align-items-center" style={{ columnGap: "10px" }}>
          <i className="fa-regular fa-clock" aria-hidden="true" style={{ color: day < 0 ? "green" : "green" }}></i> 
          <p style={{ color: day < 0 ? "green" : "green" }}>{message}</p>
        </span>
      ) : null}
    </>
  );
}